module.exports = __webpack_public_path__ + "img/guanjia-login-logo.4350c20f.png";